export default __webpack_public_path__ + "locales/pt/DownloadDialog.json?hash=58c6f2b3a1d3a99257092800a5ce6ede";